import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "./slider.css";
import img1 from "../assets/images/Gallery/gallery1.webp";
import img2 from "../assets/images/Gallery/gallery2.webp";
import img3 from "../assets/images/Gallery/gallery3.webp";
import img4 from "../assets/images/Gallery/gallery4.webp";
import img5 from "../assets/images/Gallery/gallery5.webp";
import img6 from "../assets/images/Gallery/gallery6.webp";
import img7 from "../assets/images/Gallery/gallery7.webp";
import img8 from "../assets/images/Gallery/gallery8.webp";
import img9 from "../assets/images/Gallery/gallery9.webp";
import img10 from "../assets/images/Gallery/gallery10.webp";
import img11 from "../assets/images/Gallery/gallery11.webp";
import img12 from "../assets/images/Gallery/gallery12.webp";
import img13 from "../assets/images/Gallery/gallery13.webp";
import img14 from "../assets/images/Gallery/gallery14.webp";
import { Box, Typography } from "@mui/material";
import Orangelogo from "../assets/images/Orangelogo.png";

// const imagesRight = [img1, img2, img3, img4, img5, img6, img7];

// const imagesLeft = [img8, img9, img10, img11, img12, img13, img14];

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
];

export default function DualMarqueeSlider() {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        marginTop: "2rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "column" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 3rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "3rem", sm: "2rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.4rem",
            fontWeight: "400",
          }}
        >
          MEMORIES{" "}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "0.8rem",
            marginBottom: "1.5rem",
          }}
        >
          Gallery{" "}
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
        }}
      ></Box>

      <div style={{ width: "100%", overflow: "hidden" }}>
        {/* Top Row - Continuous Right */}
        {/* <Swiper
          modules={[Autoplay, FreeMode]}
          className="my-swiper"
          spaceBetween={20}
          loop={true}
          freeMode={true}
          allowTouchMove={false} // Disable drag to preserve smooth motion
          speed={6000} // Bigger = slower and smoother
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
        >
          {imagesRight.concat(imagesRight).map(
            (
              src,
              i // Duplicate images for seamless loop
            ) => (
              <SwiperSlide key={i}>
                <img
                  src={src}
                  alt=""
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </SwiperSlide>
            )
          )}
        </Swiper> */}
        <Box sx={{ margin: "2rem" }}></Box>
        {/* Bottom Row - Continuous Left (reverse direction using CSS) */}
        <Swiper
          modules={[Autoplay]}
          className="my-swiper"
          spaceBetween={20}
          loop={true}
          allowTouchMove={false}
          speed={6000}
          slidesPerView={"auto"}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true, // Reverse scroll
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
        >
          {images.concat(images).map((src, i) => (
            <SwiperSlide key={i} style={{ width: "250px" }}>
              <img
                src={src}
                alt=""
                style={{
                  width: "100%",
                  height: "350px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Box>
  );
}
